import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';
import { ExpensesComponent } from '../expenses/expenses.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-expenses-list',
  templateUrl: './expenses-list.component.html',
  styleUrls: ['./expenses-list.component.css']
})
export class ExpensesListComponent implements OnInit {

  public menu_item_id = '49';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];

  displayedColumns = ['exp_no', 'invoice_no', 'invoice_date', 'amount', 'exp_desc', 'print', 'edit', 'del'];
  displayedColumns2 = ['exp_no', 'invoice_no', 'invoice_date', 'amount', 'exp_desc'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<ExpensesComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'expenses', 'from_date': new Date(), 'to_date': new Date(), 'invoice_no': '',
    'branch_id': '0', 'title': 'قائمة المصروفات'
  };

  from_date = '';
  to_date = '';

  branchList = [];

  Expenses_List; Success_Msg; Error_Msg; Del_Msg;
  From_Date; To_Date; Invoice_No;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Expenses_List').subscribe((res: string) => {
      this.Expenses_List = res;
    });
    this.model['title'] = this.Expenses_List;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Invoice_No').subscribe((res: string) => {
      this.Invoice_No = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
    //this.model['from_date'] = undefined;
    //this.model['to_date'] = undefined;
    // this.from_date = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + 
    //   this.model['from_date'].getDate());
    // this.to_date = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + 
    //   this.model['to_date'].getDate());

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {
    // this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + 
    //   this.model['from_date'].getDate();
    // this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + 
    //   this.model['to_date'].getDate();

    let condition = "";
    let index = 1;
    let list_length = this.branchList.length;

    if (this.model['invoice_no'] != '') {
      condition = " AND `expenses`.`invoice_no` LIKE '%" + this.model['invoice_no'] + "%'";

      if (this.branchList.length == 2)
        condition += " AND `expenses`.`branch_id` = '" + this.branchList[1]['branch_id'] + "'";
      else {
        
        condition += " AND `expenses`.`branch_id` IN (";
        this.branchList.forEach(element => {
          if (element.branch_id != '0') {
            if (index < list_length)
              condition += " '" + element.branch_id + "',";
            else if (index == list_length)
              condition += " '" + element.branch_id + "'";
          }
          index++;
        });
        condition += ")";
      }
    }
    else {
      if (this.model['from_date'] != undefined) {
        this.from_date = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
          this.model['from_date'].getDate() + ' 00:00:00');
        condition += " AND `expenses`.`invoice_date` >= '" + this.from_date + "'";
      }
      else
        this.from_date = '';
  
      if (this.model['to_date'] != undefined) {
        this.to_date = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
          this.model['to_date'].getDate() + ' 23:59:59');
        condition += " AND `expenses`.`invoice_date` <= '" + this.to_date + "'";
      }
      else
        this.to_date = '';

      if (this.model['branch_id'] != '0')
        condition += " AND `expenses`.`branch_id` = '" + this.model['branch_id'] + "'";
  
      else if (this.model['branch_id'] == '0') {

        if (this.branchList.length == 2)
          condition += " AND `expenses`.`branch_id` = '" + this.branchList[1]['branch_id'] + "'";
        else {
          
          condition += " AND `expenses`.`branch_id` IN (";
          this.branchList.forEach(element => {
            if (element.branch_id != '0') {
              if (index < list_length)
                condition += " '" + element.branch_id + "',";
              else if (index == list_length)
                condition += " '" + element.branch_id + "'";
            }
            index++;
          });
          condition += ")";
        }
      }
    }
    
    let query = "SELECT * FROM `expenses` WHERE `status` != '0'" + condition;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dp.forEach(element => {
          element.date = element.invoice_date;
          element.invoice_date = (element.invoice_date).substring(0, 10);
        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  newExp() {
    this.addDialogRef = this.dialog.open(ExpensesComponent, {
      hasBackdrop: false
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editExp(row) {
    let dialog_data = {
      'table_name': 'expenses', 'exp_id': row.exp_id,
      'exp_no': row.exp_no,
      'invoice_no': row.invoice_no,
      'invoice_date': row.date,
      'amount': row.amount,
      'flag': 'update',
      'key': 'exp_id',
      'exp_acct': row.exp_acct,
      'exp_desc': row.exp_desc,
      'paid_from': row.paid_from,
      'acct_number': row.acct_number,
      'cost_center': row.cost_center,
      'comment': row.comment,
      'branch_id': row.branch_id
    };
    this.addDialogRef = this.dialog.open(ExpensesComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delExp(exp_no) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'exp_no': exp_no }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print(exp_no = null) {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    if (exp_no == null) {
      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + (this.from_date != undefined ? this.from_date : '') + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + (this.to_date != undefined ? this.to_date : '') + '</td>';
      html_data += '<td width="33%"> ' + this.Invoice_No + ': ' + this.model['invoice_no'] + ' </td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('invoice_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?exp_no=" + exp_no, "_blank");
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
